"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicApiApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var PublicApiApi = /** @class */ (function (_super) {
    __extends(PublicApiApi, _super);
    function PublicApiApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicApiApi.prototype.aPIContactAddOrUpdatePost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsNewProfileViewModel = _a.travisBackendContactDomainViewModelsNewProfileViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/API/Contact/AddOrUpdate',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsNewProfileViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.aPIContactAddPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsNewProfileViewModel = _a.travisBackendContactDomainViewModelsNewProfileViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/API/Contact/Add',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsNewProfileViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.aPIContactUpdateUserProfileIdPost = function (_a, opts) {
        var userProfileId = _a.userProfileId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsNewProfileViewModel = _a.travisBackendContactDomainViewModelsNewProfileViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'aPIContactUpdateUserProfileIdPost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/API/Contact/Update/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsNewProfileViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.aPIMessageSendJsonPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendMessageDomainViewModelsSendMessageFromAPIWithBodyViewModel = _a.travisBackendMessageDomainViewModelsSendMessageFromAPIWithBodyViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/API/message/send/json',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendMessageDomainViewModelsSendMessageFromAPIWithBodyViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.aPIMessageSendNotePost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsSendNoteFromAPIWithBodyViewModel = _a.travisBackendPublicDomainViewModelsSendNoteFromAPIWithBodyViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/API/message/send/note',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsSendNoteFromAPIWithBodyViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.aPIMessageSendPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, messageChecksum = _a.messageChecksum, channel = _a.channel, from = _a.from, to = _a.to, conversationId = _a.conversationId, facebookReceiverId = _a.facebookReceiverId, webClientSenderId = _a.webClientSenderId, webClientReceiverId = _a.webClientReceiverId, weChatReceiverOpenId = _a.weChatReceiverOpenId, lineReceiverId = _a.lineReceiverId, subject = _a.subject, messageType = _a.messageType, messageContent = _a.messageContent, files = _a.files, fileURLs = _a.fileURLs, quotedMsgId = _a.quotedMsgId, staffUserId = _a.staffUserId, assigneeId = _a.assigneeId, extendedMessageJson = _a.extendedMessageJson, analyticTags = _a.analyticTags;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        var formData = new FormData();
        if (messageChecksum !== undefined) {
            formData.append('MessageChecksum', messageChecksum);
        }
        if (channel !== undefined) {
            formData.append('Channel', channel);
        }
        if (from !== undefined) {
            formData.append('From', from);
        }
        if (to !== undefined) {
            formData.append('To', to);
        }
        if (conversationId !== undefined) {
            formData.append('ConversationId', conversationId);
        }
        if (facebookReceiverId !== undefined) {
            formData.append('FacebookReceiverId', facebookReceiverId);
        }
        if (webClientSenderId !== undefined) {
            formData.append('WebClientSenderId', webClientSenderId);
        }
        if (webClientReceiverId !== undefined) {
            formData.append('WebClientReceiverId', webClientReceiverId);
        }
        if (weChatReceiverOpenId !== undefined) {
            formData.append('WeChatReceiverOpenId', weChatReceiverOpenId);
        }
        if (lineReceiverId !== undefined) {
            formData.append('LineReceiverId', lineReceiverId);
        }
        if (subject !== undefined) {
            formData.append('Subject', subject);
        }
        if (messageType !== undefined) {
            formData.append('MessageType', messageType);
        }
        if (messageContent !== undefined) {
            formData.append('MessageContent', messageContent);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (fileURLs !== undefined) {
            fileURLs.forEach(function (element) { return formData.append('fileURLs', element); });
        }
        if (quotedMsgId !== undefined) {
            formData.append('QuotedMsgId', quotedMsgId);
        }
        if (staffUserId !== undefined) {
            formData.append('StaffUserId', staffUserId);
        }
        if (assigneeId !== undefined) {
            formData.append('AssigneeId', assigneeId);
        }
        if (extendedMessageJson !== undefined) {
            formData.append('ExtendedMessageJson', extendedMessageJson);
        }
        if (analyticTags !== undefined) {
            analyticTags.forEach(function (element) { return formData.append('AnalyticTags', element); });
        }
        return this.request({
            url: '/API/Message/Send',
            method: 'POST',
            headers: headers,
            query: query,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.api360dialogTemplateGet = function (_a, opts) {
        var channelNumber = _a.channelNumber, apikey = _a.apikey, limit = _a.limit, offset = _a.offset, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(channelNumber, 'channelNumber', 'api360dialogTemplateGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {
            'channelNumber': channelNumber,
        };
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        return this.request({
            url: '/api/360dialog/template',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiAnalyticGet = function (_a, opts) {
        var startDate = _a.startDate, endDate = _a.endDate, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(startDate, 'startDate', 'apiAnalyticGet');
        (0, runtime_1.throwIfNullOrUndefined)(endDate, 'endDate', 'apiAnalyticGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {
            'startDate': startDate,
            'endDate': endDate,
        };
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/analytic',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiBroadcastsBroadcastIdGet = function (_a, opts) {
        var broadcastId = _a.broadcastId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastId, 'broadcastId', 'apiBroadcastsBroadcastIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/broadcasts/{broadcastId}'.replace('{broadcastId}', (0, runtime_1.encodeURI)(broadcastId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiBroadcastsBroadcastIdRecipientsGet = function (_a, opts) {
        var broadcastId = _a.broadcastId, status = _a.status, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastId, 'broadcastId', 'apiBroadcastsBroadcastIdRecipientsGet');
        (0, runtime_1.throwIfNullOrUndefined)(status, 'status', 'apiBroadcastsBroadcastIdRecipientsGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {
            'status': status,
        };
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/broadcasts/{broadcastId}/recipients'.replace('{broadcastId}', (0, runtime_1.encodeURI)(broadcastId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiBroadcastsGet = function (_a, opts) {
        var apikey = _a.apikey, offset = _a.offset, limit = _a.limit, name = _a.name, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (name != null) {
            query['name'] = name;
        }
        return this.request({
            url: '/api/broadcasts',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCloudapiTemplateGet = function (_a, opts) {
        var channelNumber = _a.channelNumber, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(channelNumber, 'channelNumber', 'apiCloudapiTemplateGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {
            'channelNumber': channelNumber,
        };
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/cloudapi/template',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactGet = function (_a, opts) {
        var apikey = _a.apikey, offset = _a.offset, limit = _a.limit, lastUpdatedAt = _a.lastUpdatedAt, afterCreatedAt = _a.afterCreatedAt, phoneNumber = _a.phoneNumber, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, isExactMatch = _a.isExactMatch, listId = _a.listId, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (lastUpdatedAt != null) {
            query['lastUpdatedAt'] = lastUpdatedAt;
        }
        if (afterCreatedAt != null) {
            query['afterCreatedAt'] = afterCreatedAt;
        }
        if (phoneNumber != null) {
            query['phoneNumber'] = phoneNumber;
        }
        if (email != null) {
            query['email'] = email;
        }
        if (firstName != null) {
            query['firstName'] = firstName;
        }
        if (lastName != null) {
            query['lastName'] = lastName;
        }
        if (isExactMatch != null) {
            query['isExactMatch'] = isExactMatch;
        }
        if (listId != null) {
            query['listId'] = listId;
        }
        return this.request({
            url: '/api/contact',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactListContactListIdAddPost = function (_a, opts) {
        var contactListId = _a.contactListId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(contactListId, 'contactListId', 'apiContactListContactListIdAddPost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/list/{contactListId}/add'.replace('{contactListId}', (0, runtime_1.encodeURI)(contactListId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactListContactListIdGet = function (_a, opts) {
        var contactListId = _a.contactListId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(contactListId, 'contactListId', 'apiContactListContactListIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/list/{contactListId}'.replace('{contactListId}', (0, runtime_1.encodeURI)(contactListId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactListContactListIdRemoveDelete = function (_a, opts) {
        var contactListId = _a.contactListId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(contactListId, 'contactListId', 'apiContactListContactListIdRemoveDelete');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/list/{contactListId}/remove'.replace('{contactListId}', (0, runtime_1.encodeURI)(contactListId)),
            method: 'DELETE',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactListContactListIdRemovePost = function (_a, opts) {
        var contactListId = _a.contactListId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(contactListId, 'contactListId', 'apiContactListContactListIdRemovePost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/list/{contactListId}/remove'.replace('{contactListId}', (0, runtime_1.encodeURI)(contactListId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactListGet = function (_a, opts) {
        var apikey = _a.apikey, offset = _a.offset, limit = _a.limit, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/api/contact/list',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactListPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/list',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactSearchPost = function (_a, opts) {
        var apikey = _a.apikey, lastUpdatedAt = _a.lastUpdatedAt, afterCreatedAt = _a.afterCreatedAt, phoneNumber = _a.phoneNumber, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, isExactMatch = _a.isExactMatch, listId = _a.listId, page = _a.page, pageSize = _a.pageSize, sortBy = _a.sortBy, sortOrder = _a.sortOrder, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendCompanyDomainModelsCondition = _a.travisBackendCompanyDomainModelsCondition;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (lastUpdatedAt != null) {
            query['lastUpdatedAt'] = lastUpdatedAt;
        }
        if (afterCreatedAt != null) {
            query['afterCreatedAt'] = afterCreatedAt;
        }
        if (phoneNumber != null) {
            query['phoneNumber'] = phoneNumber;
        }
        if (email != null) {
            query['email'] = email;
        }
        if (firstName != null) {
            query['firstName'] = firstName;
        }
        if (lastName != null) {
            query['lastName'] = lastName;
        }
        if (isExactMatch != null) {
            query['isExactMatch'] = isExactMatch;
        }
        if (listId != null) {
            query['listId'] = listId;
        }
        if (page != null) {
            query['page'] = page;
        }
        if (pageSize != null) {
            query['pageSize'] = pageSize;
        }
        if (sortBy != null) {
            query['sortBy'] = sortBy;
        }
        if (sortOrder != null) {
            query['sortOrder'] = sortOrder;
        }
        return this.request({
            url: '/api/contact/search',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainModelsCondition,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactUserProfileIdDelete = function (_a, opts) {
        var userProfileId = _a.userProfileId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'apiContactUserProfileIdDelete');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'DELETE',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiContactUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'apiContactUserProfileIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/contact/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationAllGet = function (_a, opts) {
        var apikey = _a.apikey, assignedTo = _a.assignedTo, offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, phoneNumber = _a.phoneNumber, afterUpdatedAt = _a.afterUpdatedAt, afterModifiedAt = _a.afterModifiedAt, channelIds = _a.channelIds, tags = _a.tags, teamId = _a.teamId, isTeamUnassigned = _a.isTeamUnassigned, isUnread = _a.isUnread, orderBy = _a.orderBy, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (assignedTo != null) {
            query['assignedTo'] = assignedTo;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (phoneNumber != null) {
            query['phoneNumber'] = phoneNumber;
        }
        if (afterUpdatedAt != null) {
            query['afterUpdatedAt'] = afterUpdatedAt;
        }
        if (afterModifiedAt != null) {
            query['afterModifiedAt'] = afterModifiedAt;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (isTeamUnassigned != null) {
            query['isTeamUnassigned'] = isTeamUnassigned;
        }
        if (isUnread != null) {
            query['isUnread'] = isUnread;
        }
        if (orderBy != null) {
            query['orderBy'] = orderBy;
        }
        return this.request({
            url: '/api/conversation/all',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationChannelGet = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/conversation/channel',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationConversationIdAssigneePost = function (_a, opts) {
        var conversationId = _a.conversationId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendCompanyDomainViewModelsStaffAssignmentViewModel = _a.travisBackendCompanyDomainViewModelsStaffAssignmentViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'apiConversationConversationIdAssigneePost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/conversation/{conversationId}/assignee'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsStaffAssignmentViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationConversationIdCollaboratorsPost = function (_a, opts) {
        var conversationId = _a.conversationId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendCompanyDomainViewModelsStaffAssignmentViewModel = _a.travisBackendCompanyDomainViewModelsStaffAssignmentViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'apiConversationConversationIdCollaboratorsPost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/conversation/{conversationId}/collaborators'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsStaffAssignmentViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationConversationIdGet = function (_a, opts) {
        var conversationId = _a.conversationId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'apiConversationConversationIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/conversation/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationMessageConversationIdGet = function (_a, opts) {
        var conversationId = _a.conversationId, apikey = _a.apikey, offset = _a.offset, limit = _a.limit, beforeMessageId = _a.beforeMessageId, afterMessageId = _a.afterMessageId, startTimestamp = _a.startTimestamp, endTimestamp = _a.endTimestamp, channel = _a.channel, channelIds = _a.channelIds, isFromUser = _a.isFromUser, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'apiConversationMessageConversationIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (beforeMessageId != null) {
            query['beforeMessageId'] = beforeMessageId;
        }
        if (afterMessageId != null) {
            query['afterMessageId'] = afterMessageId;
        }
        if (startTimestamp != null) {
            query['startTimestamp'] = startTimestamp;
        }
        if (endTimestamp != null) {
            query['endTimestamp'] = endTimestamp;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (isFromUser != null) {
            query['isFromUser'] = isFromUser;
        }
        return this.request({
            url: '/api/conversation/message/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiConversationMessageSearchGet = function (_a, opts) {
        var apikey = _a.apikey, keywords = _a.keywords, contactOwner = _a.contactOwner, teamId = _a.teamId, offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, channelNumber = _a.channelNumber, isGetFileOnly = _a.isGetFileOnly, tags = _a.tags, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (keywords != null) {
            query['keywords'] = keywords;
        }
        if (contactOwner != null) {
            query['contactOwner'] = contactOwner;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelNumber != null) {
            query['channelNumber'] = channelNumber;
        }
        if (isGetFileOnly != null) {
            query['isGetFileOnly'] = isGetFileOnly;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        return this.request({
            url: '/api/conversation/message/search',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsContactUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId, apiKey = _a.apiKey, limitPerCustomObject = _a.limitPerCustomObject, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'apiCustomObjectsContactUserProfileIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        if (limitPerCustomObject != null) {
            query['limitPerCustomObject'] = limitPerCustomObject;
        }
        return this.request({
            url: '/api/customObjects/contact/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyGet = function (_a, opts) {
        var objectKey = _a.objectKey, apiKey = _a.apiKey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyRecordsGet = function (_a, opts) {
        var objectKey = _a.objectKey, limit = _a.limit, apiKey = _a.apiKey, sortBy = _a.sortBy, direction = _a.direction, referencedUserProfileId = _a.referencedUserProfileId, continuationToken = _a.continuationToken, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyRecordsGet');
        (0, runtime_1.throwIfNullOrUndefined)(limit, 'limit', 'apiCustomObjectsObjectKeyRecordsGet');
        var headers = __assign(__assign({}, (continuationToken != null ? { 'ContinuationToken': String(continuationToken) } : undefined)), (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {
            'limit': limit,
        };
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        if (sortBy != null) {
            query['sortBy'] = sortBy;
        }
        if (direction != null) {
            query['direction'] = direction;
        }
        if (referencedUserProfileId != null) {
            query['referenced_user_profile_id'] = referencedUserProfileId;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}/records'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyRecordsPost = function (_a, opts) {
        var objectKey = _a.objectKey, apiKey = _a.apiKey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsSchemafulObjectViewModel = _a.travisBackendPublicDomainViewModelsSchemafulObjectViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyRecordsPost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}/records'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsSchemafulObjectViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyRecordsPrimaryPropertyValueDelete = function (_a, opts) {
        var objectKey = _a.objectKey, primaryPropertyValue = _a.primaryPropertyValue, apiKey = _a.apiKey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValueDelete');
        (0, runtime_1.throwIfNullOrUndefined)(primaryPropertyValue, 'primaryPropertyValue', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValueDelete');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}/records/{primaryPropertyValue}'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)).replace('{primaryPropertyValue}', (0, runtime_1.encodeURI)(primaryPropertyValue)),
            method: 'DELETE',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyRecordsPrimaryPropertyValueGet = function (_a, opts) {
        var objectKey = _a.objectKey, primaryPropertyValue = _a.primaryPropertyValue, apiKey = _a.apiKey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValueGet');
        (0, runtime_1.throwIfNullOrUndefined)(primaryPropertyValue, 'primaryPropertyValue', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValueGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}/records/{primaryPropertyValue}'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)).replace('{primaryPropertyValue}', (0, runtime_1.encodeURI)(primaryPropertyValue)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyRecordsPrimaryPropertyValuePartialUpdatePut = function (_a, opts) {
        var objectKey = _a.objectKey, primaryPropertyValue = _a.primaryPropertyValue, apiKey = _a.apiKey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsSchemafulObjectViewModel = _a.travisBackendPublicDomainViewModelsSchemafulObjectViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValuePartialUpdatePut');
        (0, runtime_1.throwIfNullOrUndefined)(primaryPropertyValue, 'primaryPropertyValue', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValuePartialUpdatePut');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}/records/{primaryPropertyValue}/partialUpdate'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)).replace('{primaryPropertyValue}', (0, runtime_1.encodeURI)(primaryPropertyValue)),
            method: 'PUT',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsSchemafulObjectViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiCustomObjectsObjectKeyRecordsPrimaryPropertyValuePut = function (_a, opts) {
        var objectKey = _a.objectKey, primaryPropertyValue = _a.primaryPropertyValue, apiKey = _a.apiKey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsSchemafulObjectViewModel = _a.travisBackendPublicDomainViewModelsSchemafulObjectViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(objectKey, 'objectKey', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValuePut');
        (0, runtime_1.throwIfNullOrUndefined)(primaryPropertyValue, 'primaryPropertyValue', 'apiCustomObjectsObjectKeyRecordsPrimaryPropertyValuePut');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apiKey != null) {
            query['apiKey'] = apiKey;
        }
        return this.request({
            url: '/api/customObjects/{objectKey}/records/{primaryPropertyValue}'.replace('{objectKey}', (0, runtime_1.encodeURI)(objectKey)).replace('{primaryPropertyValue}', (0, runtime_1.encodeURI)(primaryPropertyValue)),
            method: 'PUT',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsSchemafulObjectViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiGenerateAPIKeyPost = function (_a, opts) {
        var travisBackendCoreDomainModelsCoreIssueAPIKey = _a.travisBackendCoreDomainModelsCoreIssueAPIKey;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/api/generate/APIKey',
            method: 'POST',
            headers: headers,
            body: travisBackendCoreDomainModelsCoreIssueAPIKey,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiLabelsDelete = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendMessageDomainViewModelsConversationHashtagViewModel = _a.travisBackendMessageDomainViewModelsConversationHashtagViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/labels',
            method: 'DELETE',
            headers: headers,
            query: query,
            body: travisBackendMessageDomainViewModelsConversationHashtagViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiLabelsGet = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/labels',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiLabelsPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendMessageDomainViewModelsConversationHashtagViewModel = _a.travisBackendMessageDomainViewModelsConversationHashtagViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/labels',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendMessageDomainViewModelsConversationHashtagViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiQuickRepliesDelete = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsDeleteQuickReplyViewModel = _a.travisBackendPublicDomainViewModelsDeleteQuickReplyViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/quick-replies',
            method: 'DELETE',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsDeleteQuickReplyViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiQuickRepliesGet = function (_a, opts) {
        var apikey = _a.apikey, offset = _a.offset, limit = _a.limit, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/api/quick-replies',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiQuickRepliesPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsCreateQuickReplyViewModel = _a.travisBackendPublicDomainViewModelsCreateQuickReplyViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/quick-replies',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsCreateQuickReplyViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiQuickRepliesPut = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsUpdateQuickReplyViewModel = _a.travisBackendPublicDomainViewModelsUpdateQuickReplyViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/quick-replies',
            method: 'PUT',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsUpdateQuickReplyViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiStaffsGet = function (_a, opts) {
        var apikey = _a.apikey, phoneNumber = _a.phoneNumber, email = _a.email, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        if (phoneNumber != null) {
            query['phoneNumber'] = phoneNumber;
        }
        if (email != null) {
            query['email'] = email;
        }
        return this.request({
            url: '/api/staffs',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiStaffsPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendPublicDomainViewModelsCreateStaffViewModel = _a.travisBackendPublicDomainViewModelsCreateStaffViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/staffs',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendPublicDomainViewModelsCreateStaffViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiStaffsStaffUserIdConversationsSummaryGet = function (_a, opts) {
        var staffUserId = _a.staffUserId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(staffUserId, 'staffUserId', 'apiStaffsStaffUserIdConversationsSummaryGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/staffs/{staffUserId}/conversations/summary'.replace('{staffUserId}', (0, runtime_1.encodeURI)(staffUserId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiStaffsStaffUserIdDelete = function (_a, opts) {
        var staffUserId = _a.staffUserId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(staffUserId, 'staffUserId', 'apiStaffsStaffUserIdDelete');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/staffs/{staffUserId}'.replace('{staffUserId}', (0, runtime_1.encodeURI)(staffUserId)),
            method: 'DELETE',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiStaffsStaffUserIdGet = function (_a, opts) {
        var staffUserId = _a.staffUserId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(staffUserId, 'staffUserId', 'apiStaffsStaffUserIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/staffs/{staffUserId}'.replace('{staffUserId}', (0, runtime_1.encodeURI)(staffUserId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTeamsGet = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/teams',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTeamsPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendCompanyDomainViewModelsCreateNewTeamViewModel = _a.travisBackendCompanyDomainViewModelsCreateNewTeamViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/teams',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsCreateNewTeamViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTeamsTeamIdAddStaffsPost = function (_a, opts) {
        var teamId = _a.teamId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendCompanyDomainViewModelsCreateNewTeamViewModel = _a.travisBackendCompanyDomainViewModelsCreateNewTeamViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(teamId, 'teamId', 'apiTeamsTeamIdAddStaffsPost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/teams/{teamId}/addStaffs'.replace('{teamId}', (0, runtime_1.encodeURI)(teamId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsCreateNewTeamViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTeamsTeamIdDelete = function (_a, opts) {
        var teamId = _a.teamId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(teamId, 'teamId', 'apiTeamsTeamIdDelete');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/teams/{teamId}'.replace('{teamId}', (0, runtime_1.encodeURI)(teamId)),
            method: 'DELETE',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTeamsTeamIdGet = function (_a, opts) {
        var teamId = _a.teamId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(teamId, 'teamId', 'apiTeamsTeamIdGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/teams/{teamId}'.replace('{teamId}', (0, runtime_1.encodeURI)(teamId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTeamsTeamIdRemoveStaffsPost = function (_a, opts) {
        var teamId = _a.teamId, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendCompanyDomainViewModelsCreateNewTeamViewModel = _a.travisBackendCompanyDomainViewModelsCreateNewTeamViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(teamId, 'teamId', 'apiTeamsTeamIdRemoveStaffsPost');
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/teams/{teamId}/removeStaffs'.replace('{teamId}', (0, runtime_1.encodeURI)(teamId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsCreateNewTeamViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiTwilioTemplateGet = function (_a, opts) {
        var twilioAccountSid = _a.twilioAccountSid, apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        (0, runtime_1.throwIfNullOrUndefined)(twilioAccountSid, 'twilioAccountSid', 'apiTwilioTemplateGet');
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {
            'twilioAccountSid': twilioAccountSid,
        };
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/twilio/template',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiVerifyEndpointPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey;
        var headers = __assign({}, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/verifyEndpoint',
            method: 'POST',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    PublicApiApi.prototype.apiWhatsappReplyWindowStatusPost = function (_a, opts) {
        var apikey = _a.apikey, xSleekflowApiKey = _a.xSleekflowApiKey, travisBackendConversationDomainViewModelsCheckWhatsappConversationSessionStatusViewModel = _a.travisBackendConversationDomainViewModelsCheckWhatsappConversationSessionStatusViewModel;
        var headers = __assign({ 'Content-Type': 'application/json-patch+json' }, (xSleekflowApiKey != null ? { 'X-Sleekflow-Api-Key': String(xSleekflowApiKey) } : undefined));
        var query = {};
        if (apikey != null) {
            query['apikey'] = apikey;
        }
        return this.request({
            url: '/api/whatsapp/reply-window-status',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendConversationDomainViewModelsCheckWhatsappConversationSessionStatusViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return PublicApiApi;
}(runtime_1.BaseAPI));
exports.PublicApiApi = PublicApiApi;
